export default __webpack_public_path__ + "static/cordelia-3fa1a0cf80b207e62338e72a15a36089.jpg";